import { Admission } from '@domain/admission';
import { Preset } from '@domain/preset';

export const getAdmissionDDPPrice = (admission: Admission | Preset) =>
  admission.settings?.italyRegulation?.dirittoPrevendita;
